import { render, staticRenderFns } from "./productPicker.vue?vue&type=template&id=5ab4b828&scoped=true"
import script from "./productPicker.vue?vue&type=script&lang=js"
export * from "./productPicker.vue?vue&type=script&lang=js"
import style0 from "./productPicker.vue?vue&type=style&index=0&id=5ab4b828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab4b828",
  null
  
)

export default component.exports